type MultiOrderDiscount = {
  code?: string;
  recurringCycleLimit?: number | null;
} | null;

// null for first-order (cycle is 1) and forever codes (cycle is 0)
export const getMultiOrderCount = (
  discount: MultiOrderDiscount | false | undefined,
): number | null => {
  const limit = discount ? discount.recurringCycleLimit : null;
  return limit && limit > 1 ? limit : null;
};

// The same, for the code applied to the cart. discountInfo can lag behind a
// newly applied code, so it only counts when it describes that code.
export const getAppliedMultiOrderCount = (
  promoCode: string | null | undefined,
  discountInfo: MultiOrderDiscount | undefined,
): number | null =>
  promoCode && discountInfo?.code?.toUpperCase() === promoCode.toUpperCase()
    ? getMultiOrderCount(discountInfo)
    : null;
